import { IKeyedObject } from '@dirootie-extensions/typescript';
import _ from 'lodash';
import {
  allPass,
  append,
  endsWith,
  filter,
  forEach,
  isNil,
  join,
  map,
  not,
  o,
  propOr,
  replace,
  slice,
  split,
  toLower,
  toUpper,
  unless,
} from 'ramda';
import {
  ensureArray,
  isNotNilOrEmpty,
  replaceAll,
} from 'ramda-adjunct';

const startCase = unless(isNil, replace(/^./, toUpper));

const titleCase = o(startCase, unless(isNil, toLower));

const removeChar = (c: string | string[], target: string) => {
  const pred = allPass(map((x: any) => (el: any) => el !== x, ensureArray(c)));
  const result = join('', filter(pred, Array.from(target)));
  return result;
};

const template = (template: string, options: IKeyedObject<string>) => {
  const replacer = (_: string, key: string): string => propOr('not_set', key, options);
  return replace(/{(\w+)}/g, replacer, template);
};

const replaceAllList = (
  list: [searchValue: string, replaceValue: string][],
  target: string
) => {
  let result = target;
  forEach((x: any) => {
    result = replaceAll(x[0], x[1], result);
  }, list);
  return result;
};

// const filterInvalid = filter(isNotNilOrEmpty);



export interface StringUtils {
  replaceAllList: typeof replaceAllList;
  removeChar: typeof removeChar;
  startCase: typeof startCase;
  titleCase: typeof titleCase;
  splitByDot: (str: string) => string[];
  splitBySpace: (str: string) => string[];
  splitBySlash: (str: string) => string[];
  splitByBackslash: (str: string) => string[];
  // filterInvalid: typeof filterInvalid;
  // pluralize: typeof pluralize;
  // singularize: typeof singularize;
  template: typeof template;
}

const internalStringUtils = (): StringUtils => {
  return {
    replaceAllList,
    removeChar,
    startCase,
    titleCase,
    splitByDot: split('.'),
    splitBySpace: split(' '),
    splitBySlash: split('/'),
    splitByBackslash: split('\\'),
    // filterInvalid,
    // pluralize,
    // singularize,
    template,
  };
};

export const stringUtils = internalStringUtils();
